import React from 'react'
import { uploadIcon } from '../assets/svgs';

const Input = ({setFile, types, setError}) => {

    const handleFile = (e) =>{
        let selected = e.target.files[0];
        if(selected){
            if(types.includes(selected.type)){
                setFile(selected)
                console.log(URL.createObjectURL(selected))
                setError('')
                console.log(selected)
            }else{
                setError('Image should be (jpeg/jpg/png) type')
                setFile(null)
            }
        }
    }

    return (
        <div className="upload-image">
            <label htmlFor="file-input">
                <div className="upload-button">
                    <p>Upload File</p>
                    <span>{uploadIcon}</span>
                </div>
            </label>
            <input id="file-input" type='file' onChange={handleFile}/>
        </div>
    )
}

export default Input
